import { notificationIconMap } from '@aibees/elephant/utils';
import { useDeletePresetMutationApi } from '@aibees/shared/api';
import { DialogTitle, FormOnSubmit } from '@aibees/shared/components';
import { useBoolean, useNotify } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils/class-names';
import { LoadingButton } from '@mui/lab';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Fade,
} from '@mui/material';
import { memo } from 'react';
import { DeleteTitleDialog } from '../delete-title-dialog';
import * as Styled from './styles';
import type { DeleteActionProps as Props } from './types';

export const SearchListDeleteAction = memo(
  ({ className, item, state }: Props) => {
    const notify = useNotify();
    const api = useDeletePresetMutationApi(item.id);
    const loading = useBoolean();

    const handleClose = () => {
      state?.onFalse();
    };

    const handleSubmit: FormOnSubmit = () => {
      const key = Date.now().toString();
      api.mutateAsync({}).then(() => {
        notify.complete(
          'Saved Search Deleted',
          'Saved Search deleted successfully.',
          key,
          {
            icon: notificationIconMap.SaveSearch,
          }
        );
        loading.onToggle();
        handleClose();
      });
    };

    return (
      <Styled.Wrapper
        className={classnames('SearchListDeleteAction', className)}
      >
        <Dialog
          open={state.value}
          maxWidth="xs"
          fullWidth={true}
          TransitionComponent={Fade}
          onClose={handleClose}
        >
          <DialogTitle
            title="Delete Saved Search"
            icon="delete"
            onClose={handleClose}
          />

          <DialogContent>
            <DeleteTitleDialog name={item.name} type={item.type} />
          </DialogContent>

          <DialogActions>
            <Button
              children="Cancel"
              variant="text"
              color="default"
              size="small"
              onClick={handleClose}
            />

            <LoadingButton
              children="Delete"
              variant="contained"
              color="error"
              size="small"
              loading={loading.value}
              onClick={handleSubmit}
            />
          </DialogActions>
        </Dialog>
      </Styled.Wrapper>
    );
  }
);

SearchListDeleteAction.displayName = 'SearchListDeleteAction';
